import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { InfoProfileService } from '../info-profile.service';
import { UserProfile } from '../user-profile.model';

@Component({
  selector: 'app-user-profile-container',
  templateUrl: './user-profile-container.component.html',
  styleUrls: ['./user-profile-container.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UserProfileContainerComponent implements OnInit, OnDestroy {

  userName: string;
  menuOpened: boolean;
  private userSubscription: Subscription;

  constructor(private infoProfileService: InfoProfileService) { }

  ngOnInit() {

    this.userSubscription = this.infoProfileService.getUserProfile().subscribe((userProfile: UserProfile) => {

      if (userProfile)
        this.userName = this.formatUserName(userProfile.userName);
    });
  }

  openMenu(): void {

    this.menuOpened = true;
  }

  onCloseMenu(closeEvent: boolean): void {

    this.menuOpened = !closeEvent;
  }

  ngOnDestroy() {

    this.userSubscription.unsubscribe();
  }

  private formatUserName(fullName: string): string {
    let result = fullName.split(' ');
    return result[0].trim();
  }

}
